export default __webpack_public_path__ + "static/media/telegram.25e32840.svg";